import script from "./WithBandSizeMixin.vue?vue&type=script&lang=ts"
export * from "./WithBandSizeMixin.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__